var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_GET_REWARD, API_GET_VOUCHER_LIST, API_POST_LOBBY_OPEN_EVENT, API_POST_REDEEM_VOUCHER, API_POST_USER_ENGAGEMENT_EVENT, } from ".";
import { collectActivityStream } from "./utils/collect.utils";
// measure engagement
export const recordChatLevelEvent = (api, level, userInfo, data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield api.post(API_POST_USER_ENGAGEMENT_EVENT, {
            event: `chat_level_${level}`,
            event_data: data,
        });
        // no need to collect activity stream for chat level event
        // collectActivityStream(userInfo, `chat_level_${level}`, data);
    }
    catch (err) {
        console.error(`Record chat level event failed, reason:(${err.message})`);
    }
});
export const recordHeartbeatEvent = (api, userInfo, data, analyticsURI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield api.post(API_POST_USER_ENGAGEMENT_EVENT, {
            event: "heartbeat",
            event_data: data,
        });
        collectActivityStream(userInfo, "heartbeat", data, analyticsURI);
    }
    catch (err) {
        console.error(`Record heartbeat event failed, reason:(${err.message})`);
    }
});
export const recordNFTSentEvent = (api, userInfo, data, analyticsURI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield api.post(API_POST_USER_ENGAGEMENT_EVENT, {
            event: "nft_sent",
            event_data: data,
        });
        collectActivityStream(userInfo, "nft_sent", data, analyticsURI);
    }
    catch (err) {
        console.error(`Record NFT sent event failed, reason:(${err.message})`);
    }
});
export const recordLobbyOpenEvent = (api, userInfo, data, analyticsURI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield api.post(API_POST_LOBBY_OPEN_EVENT, {
            hashed_domain: data.hashed_domain,
            url: data.url,
        });
        collectActivityStream(userInfo, "lobby_open", data, analyticsURI);
    }
    catch (err) {
        console.error(`Record Lobby open event failed, reason:(${err.message})`);
    }
});
export const recordAdsEvent = (api, userInfo, data, analyticsURI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        collectActivityStream(userInfo, "ads_event", data, analyticsURI);
        // collectActivityStream(userInfo, "ads_open", data, analyticsURI);
    }
    catch (err) {
        console.error(`Record Ads open event failed, reason:(${err.message})`);
    }
});
export const recordTrendLobbyClickEvent = (api, userInfo, data, analyticsURI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        collectActivityStream(userInfo, "trending_lobby_click", data, analyticsURI);
        // collectActivityStream(userInfo, "ads_open", data, analyticsURI);
    }
    catch (err) {
        console.error(`Record trending lobby click event failed, reason:(${err.message})`);
    }
});
export const recordRewardsPageClickEvent = (api, userInfo, data, analyticsURI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        collectActivityStream(userInfo, "rewards_page_click", data, analyticsURI);
        // collectActivityStream(userInfo, "ads_open", data, analyticsURI);
    }
    catch (err) {
        console.error(`Record rewards page click event failed, reason:(${err.message})`);
    }
});
export const recordClickEvent = (api, userInfo, data, analyticsURI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        collectActivityStream(userInfo, "click", data, analyticsURI);
        // collectActivityStream(userInfo, "ads_open", data, analyticsURI);
    }
    catch (err) {
        console.error(`Record click event failed, reason:(${err.message})`);
    }
});
export const recordRecommendationEvent = (api, userInfo, data, analyticsURI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        collectActivityStream(userInfo, "recommendation", data, analyticsURI);
    }
    catch (err) {
        console.error(`Record click event failed, reason:(${err.message})`);
    }
});
export const recordPageViewEvent = (api, userInfo, data, analyticsURI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        collectActivityStream(userInfo, "page_view", data, analyticsURI);
    }
    catch (err) {
        console.error(`Record page_view event failed, reason:(${err.message})`);
    }
});
export const rewardFetcher = (api, domain) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_GET_REWARD, {
            params: { domain, timestamp: Date.now() },
        });
        return response.data;
    }
    catch (err) {
        throw Error("Fetching reward failed.");
    }
});
export const voucherFetcher = (api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_GET_VOUCHER_LIST);
        const voucherList = response.data;
        return voucherList.sort((a, b) => {
            if (a.token < b.token)
                return -1;
            if (a.token > b.token)
                return 1;
            return 0;
        });
    }
    catch (err) {
        throw Error("Fetching voucherList failed.");
    }
});
export const redeemProticoVoucher = (api, data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield api.post(API_POST_REDEEM_VOUCHER, data);
    if (response.status === 400) {
        throw new Error(response.data);
    }
});
//# sourceMappingURL=engagement.js.map